/* unplugin-vue-components disabled */import { render } from "./HomeNewsTwo.vue?vue&type=template&id=d57d1f46&scoped=true"
import script from "./HomeNewsTwo.vue?vue&type=script&lang=js"
export * from "./HomeNewsTwo.vue?vue&type=script&lang=js"

import "./HomeNewsTwo.vue?vue&type=style&index=0&id=d57d1f46&lang=scss&scoped=true"
import "./HomeNewsTwo.vue?vue&type=style&index=1&id=d57d1f46&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57d1f46"]])

export default __exports__